const WA_NUMBER = "5511923169450";
const WA_DEFAULT_MSG = "Olá! Gostaria de saber mais sobre as peças da Ray Melo Boutique.";

export default function WhatsAppButton() {
  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_DEFAULT_MSG)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white pl-3 pr-4 py-3 rounded-full shadow-lg cursor-pointer group transition-all duration-300 hover:bg-[#1ebe5d] hover:shadow-xl"
      style={{ boxShadow: "0 4px 20px rgba(37,211,102,0.35)" }}
    >
      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
        <i className="ri-whatsapp-line text-xl" />
      </div>
      <span className="text-[11px] tracking-[0.12em] font-semibold whitespace-nowrap overflow-hidden max-w-0 group-hover:max-w-xs transition-all duration-500 opacity-0 group-hover:opacity-100">
        FALE CONOSCO
      </span>
    </a>
  );
}
